import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip,
  Col,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";
import tutorsModal from "models/tutors.modal";

import { Link } from "react-router-dom";
import parentsModal from "models/parents.modal";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "../../assets/css/test.css";
import Loader from "components/loader/Loader";

const Notification = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = (modalName) => {
    setModal(!modal);
  };
  const [totalpage, setTotalpage] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const getListData = async () => {
    setIsLoading(true);
    
    // Dummy data for notifications
    const dummyNotificationData = {
      data: {
        data: [
          {
            _id: "1",
            title: "New Course Launch - Mathematics Advanced",
            description: "We are excited to announce the launch of our new advanced mathematics course for Class 12 students preparing for JEE.",
            image: "https://via.placeholder.com/150/0066FF/FFFFFF?text=Math+Course",
            notification_type: "Course Update",
            sheduledFor: "2024-01-25T10:00:00Z",
            updatedAt: "2024-01-20T14:30:00Z"
          },
          {
            _id: "2",
            title: "System Maintenance Notice",
            description: "Scheduled maintenance will be performed on our platform from 2 AM to 4 AM IST on January 28th. Services may be temporarily unavailable.",
            image: "https://via.placeholder.com/150/FF6600/FFFFFF?text=Maintenance",
            notification_type: "System Alert",
            sheduledFor: "2024-01-28T02:00:00Z",
            updatedAt: "2024-01-21T09:15:00Z"
          },
          {
            _id: "3",
            title: "Parent-Teacher Meeting Scheduled",
            description: "Monthly parent-teacher meetings are scheduled for the first week of February. Please check your dashboard for specific timings.",
            image: "https://via.placeholder.com/150/00CC66/FFFFFF?text=PTM",
            notification_type: "Event",
            sheduledFor: "2024-02-05T16:00:00Z",
            updatedAt: "2024-01-22T11:45:00Z"
          },
          {
            _id: "4",
            title: "New Tutor Registration Open",
            description: "We are now accepting applications from qualified tutors for Physics and Chemistry subjects. Apply now to join our teaching community.",
            image: "https://via.placeholder.com/150/9933CC/FFFFFF?text=Tutor+Reg",
            notification_type: "Recruitment",
            sheduledFor: "fill",
            updatedAt: "2024-01-23T08:20:00Z"
          },
          {
            _id: "5",
            title: "Holiday Schedule Update",
            description: "Classes will be suspended from February 15th to 17th due to national holidays. Regular schedule will resume from February 18th.",
            image: "https://via.placeholder.com/150/FF3366/FFFFFF?text=Holiday",
            notification_type: "Schedule",
            sheduledFor: "2024-02-15T00:00:00Z",
            updatedAt: "2024-01-24T13:10:00Z"
          },
          {
            _id: "6",
            title: "Mock Test Series Available",
            description: "New mock test series for board exams and competitive exams are now available. Students can access them from their dashboard.",
            image: "https://via.placeholder.com/150/33CCFF/FFFFFF?text=Mock+Test",
            notification_type: "Academic",
            sheduledFor: "fill",
            updatedAt: "2024-01-25T10:30:00Z"
          }
        ],
        meta: {
          current_page: 1,
          per_page: 10,
          total_page: 1,
          total: 6
        }
      }
    };
    
    setTimeout(() => {
      setIsLoading(false);
      setDataList(dummyNotificationData);
      setTotalpage(dummyNotificationData.data.meta.total_page);
      setCurrentPage(dummyNotificationData.data.meta.current_page);
      setPerPage(dummyNotificationData.data.meta.per_page);
    }, 1000);
  };

  useEffect(() => {
    getListData();
  }, [location]);
  useEffect(() => {
    getListData();
  }, [currentPage]);

  // console.log(dataList, "dataListparentlist");

  const handleDel = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this Message", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          parentsModal.removeParent(delId).then((res) => {
            helper.sweetalert.toast(res.data?.message);
            getListData();
          });
        }
      });
  };

  const tableRef = useRef(null);
  const downloadPDF = () => {
    const input = tableRef.current;

    if (!input) {
      console.error("Table element not found.");
      return;
    }

    // Hide action column before capturing the table

    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const width = pdf.internal.pageSize.getWidth();
        const height = (canvas.height * width) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, width, height);
        pdf.save("tutors_list.pdf");
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };
  const sideLeftStatusData = [
    {
      name: "Qualified (9)",
      textcolor: "black",
      textfontSize: "14px",
      textbackgroundColor: "white",
      iconColor: "green",
      iconbackgroundColor: "",
      iconSize: "15px",
      icon: <i className="fa-solid fa-square"></i>,
      textFontWeight: "bold",
    },
    {
      name: "Tutors Shortlisted (11)",
      textcolor: "black",
      textfontSize: "14px",
      textbackgroundColor: "white",
      iconColor: "orange",
      iconbackgroundColor: "",
      iconSize: "15px",
      icon: <i className="fa-solid fa-square"></i>,
    },
    {
      name: "Demo Schedule (12)",
      textcolor: "black",
      textfontSize: "14px",
      textbackgroundColor: "white",
      iconColor: "#f5d693",
      iconbackgroundColor: "",
      iconSize: "15px",
      icon: <i className="fa-solid fa-square"></i>,
    },
    {
      name: " Tutor Approved by Parent (17)",
      textcolor: "black",
      textfontSize: "14px",
      textbackgroundColor: "white",
      iconColor: "#ffba7d",
      iconbackgroundColor: "",
      iconSize: "15px",
      icon: <i className="fa-solid fa-square"></i>,
    },
    {
      name: "Demo Given (36)",
      textcolor: "black",
      textfontSize: "14px",
      textbackgroundColor: "white",
      iconColor: "#f5bba4",
      iconbackgroundColor: "",
      iconSize: "15px",
      icon: <i className="fa-solid fa-square"></i>,
    },
    {
      name: "Demo Approved (98)",
      textcolor: "black",
      textfontSize: "14px",
      textbackgroundColor: "white",
      iconColor: "#93f5ba",
      iconbackgroundColor: "",
      iconSize: "15px",
      icon: <i className="fa-solid fa-square"></i>,
    },
    {
      name: "offer Given (50)",
      textcolor: "black",
      textfontSize: "14px",
      textbackgroundColor: "white",
      iconColor: "#b9f593",
      iconbackgroundColor: "",
      iconSize: "15px",
      icon: <i className="fa-solid fa-square"></i>,
    },
    {
      name: "Payment Done (1)",
      textcolor: "black",
      textfontSize: "14px",
      textbackgroundColor: "white",
      iconColor: "#b9f593",
      iconbackgroundColor: "",
      iconSize: "15px",
      icon: <i className="fa-solid fa-square"></i>,
    },
    {
      name: "Rejected by Parent (45)",
      textcolor: "black",
      textfontSize: "14px",
      textbackgroundColor: "white",
      iconColor: "#dbf593",
      iconbackgroundColor: "",
      iconSize: "15px",
      icon: <i className="fa-solid fa-square"></i>,
    },
    {
      name: "Demo Rejected (14)",
      textcolor: "black",
      textfontSize: "14px",
      textbackgroundColor: "white",
      iconColor: "#f5eb93",
      iconbackgroundColor: "",
      iconSize: "15px",
      icon: <i className="fa-solid fa-square"></i>,
    },
    {
      name: "Disqualified(17)",
      textcolor: "black",
      textfontSize: "14px",
      textbackgroundColor: "white",
      iconColor: "#f5eb93",
      iconbackgroundColor: "",
      iconSize: "15px",
      icon: <i className="fa-solid fa-square"></i>,
    },
    {
      name: "Tutor Not Found(17)",
      textcolor: "black",
      textfontSize: "14px",
      textbackgroundColor: "white",
      iconColor: "#f5eb93",
      iconbackgroundColor: "",
      iconSize: "15px",
      icon: <i className="fa-solid fa-square"></i>,
    },
  ];
  const [searchTerm, setSearchTerm] = useState(""); // State to store search input

  // Filtered data based on search term
  const filteredData = dataList?.data?.data?.filter(
    (item) =>
      item?.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.notification_type
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      item?.sheduledFor?.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const openImageInPopup = (imageUrl) => {
    const width = 600; // Width of the popup
    const height = 400; // Height of the popup
    const left = (window.innerWidth - width) / 2; // Center the popup
    const top = (window.innerHeight - height) / 2; // Center the popup

    window.open(
      imageUrl,
      "_blank",
      `width=${width},height=${height},top=${top},left=${left}`
    );
  };
  return (
    <>
      <div className="pt-7 px-4">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex flex-column flex-md-row justify-content-between align-items-center">
                <h3 className="mb-2 mb-md-0">All Notification/Notice</h3>

                <div className="d-flex flex-column flex-md-row justify-content-between ">
                  <Input
                    className="mr-md-4 mb-2 mb-md-0 ml-md-4"
                    type="text"
                    placeholder="Search"
                    size="sm"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)} // Update search term state
                  />
                  {/* <Button
                      size="sm"
                      onClick={downloadPDF}
                      // style={{ width: "1x" }}
                    >
                      <i class="fa-solid fa-download"></i>
                    </Button> */}
                  <Button
                    size="sm"
                    // onClick={downloadPDF}
                    style={{ width: "100%" }}
                    to="/admin/AddNotification"
                    tag={Link}
                  >
                    Add New Notification/Notice
                  </Button>
                </div>
                {/* 
                <div className="d-flex flex-row"></div> */}
              </CardHeader>

              <div
                ref={tableRef}
                style={{ maxWidth: "100%", overflowX: "hide" }}
              >
                <Row>
                  <Col md={12}>
                    <Table
                      className="align-items-center table-flush"
                      responsive
                    >
                      <thead className="thead-light">
                        <tr>
                          <th scope="col" id="tableheding">
                            S.NO
                          </th>
                          <th scope="col" id="tableheding">
                            Title
                          </th>
                          <th scope="col" id="tableheding">
                            Image
                          </th>
                          <th scope="col" id="tableheding">
                            Description
                          </th>
                          <th scope="col" id="tableheding">
                            Type
                          </th>
                          <th scope="col" id="tableheding">
                            Scheduled On
                          </th>
                          <th scope="col" id="tableheding">
                            Created On
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <tr>
                            <td
                              colSpan={12}
                              className="text-center align-middle w-full"
                            >
                              Please wait...
                              <Loader />
                            </td>
                          </tr>
                        ) : filteredData && filteredData.length > 0 ? (
                          filteredData.map((item, index) => {
                            const formattedDate = new Date(
                              item?.updatedAt
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            });
                            const formattedDate1 = new Date(
                              item?.sheduledFor
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            });
                            const formattedUpdatedTime = new Date(
                              item?.updatedAt
                            ).toLocaleTimeString("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            });

                            return (
                              <tr
                                key={item._id}
                                style={{
                                  cursor: "pointer",
                                  padding: "0px",
                                }}
                              >
                                <td
                                  style={{ padding: "0.3rem" }}
                                  id="tabledata"
                                >
                                  {index + 1}
                                </td>
                                <td
                                  style={{ padding: "0.3rem" }}
                                  id="tabledata"
                                >
                                  {item?.title}
                                </td>
                                <td
                                  style={{ padding: "0.3rem" }}
                                  id="tabledata"
                                  onClick={() => openImageInPopup(item?.image)}
                                >
                                  <img
                                    src={item?.image}
                                    alt="Image"
                                    height="50px"
                                    width="50px"
                                  />
                                </td>
                                <td
                                  style={{ padding: "0.3rem" }}
                                  id="tabledata"
                                >
                                  {item?.description}
                                </td>
                                <td
                                  style={{ padding: "0.3rem" }}
                                  id="tabledata"
                                >
                                  {item?.notification_type}
                                </td>
                                <td
                                  style={{ padding: "0.3rem" }}
                                  id="tabledata"
                                >
                                  {item?.sheduledFor === "fill"
                                    ? "No schedule"
                                    : `${formattedDate1} at ${formattedUpdatedTime}`}
                                </td>
                                <td
                                  style={{ padding: "0.3rem" }}
                                  id="tabledata"
                                >
                                  {formattedDate}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan="6" style={{ verticalAlign: "middle" }}>
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </div>

              <CardFooter className="py-4">
                <TablePagination
                    totalPages={totalpage}
                    currentPage={currentPage}
                  pageUrl="/admin/notification?"
                />
              </CardFooter>
            </Card>
          </div>
        </Row>

        <AddModal
          modal={modal}
          Name="Add6"
          toggle={toggleModal}
          title="Add Fare management"
        />
      </div>
    </>
  );
};

export default Notification;
